"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var components_1 = require("@lsg/components");

var react_components_1 = require("@lws/react-components");

var util_1 = require("@lws/react-components/dist/components/RichTextRenderer/renderers/util");

var StageLikeComponent_1 = require("./StageLikeComponent");

var StageHeadline_1 = require("./StageHeadline");

var StageCtaButton_1 = require("./StageCtaButton");

var utils_1 = require("../../utils");

exports.StageComponent = function (_a) {
  var data = _a.data;

  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;

  var overline = data.text('overline');
  var headline = data.richText('headline');
  var subline = data.richText('subline');
  var darkTheme = data["boolean"]('darkTheme', false);
  var scrollerLabel = data.text('scrollerLabel', '');
  var background = data.field('background');
  var backgroundFocalPoint = background.object('focalPoint');
  var backgroundImage = background.asset('image').fluid();
  var ctaLabel = data.text('ctaLabel');
  var ctaTarget = data.text('ctaTarget');
  var theme = darkTheme ? components_1.Themes.DARK : components_1.Themes.LIGHT;

  if (!backgroundImage) {
    return react_1["default"].createElement(StageLikeComponent_1.StageLikeComponent, {
      data: data
    });
  }

  var image = background.field('image').raw();
  var originalWidth = (_f = (_e = (_d = (_c = (_b = image) === null || _b === void 0 ? void 0 : _b.localFile) === null || _c === void 0 ? void 0 : _c.childImageSharp) === null || _d === void 0 ? void 0 : _d.original) === null || _e === void 0 ? void 0 : _e.width, _f !== null && _f !== void 0 ? _f : undefined);
  var originalHeight = (_l = (_k = (_j = (_h = (_g = image) === null || _g === void 0 ? void 0 : _g.localFile) === null || _h === void 0 ? void 0 : _h.childImageSharp) === null || _j === void 0 ? void 0 : _j.original) === null || _k === void 0 ? void 0 : _k.height, _l !== null && _l !== void 0 ? _l : undefined);
  var relativeFocalPoint = utils_1.calculateRelativeImageFocalPointFrom((_m = backgroundFocalPoint) === null || _m === void 0 ? void 0 : _m.focalPoint, originalWidth, originalHeight);
  return react_1["default"].createElement(components_1.Stage, {
    headline: headline && react_1["default"].createElement(StageHeadline_1.StageHeadline, {
      overline: overline,
      headline: headline
    }),
    leadText: subline && react_1["default"].createElement("span", null, react_1["default"].createElement(react_components_1.ContentfulRichTextRenderer, {
      content: subline,
      options: util_1.footnotesFragmentsOptions
    })),
    scrollerText: scrollerLabel,
    imgAltText: 'alternative image text',
    imageSrc: backgroundImage.base64 || backgroundImage.src,
    imageSrcMobile: backgroundImage.src,
    imageSrcTablet: backgroundImage.src,
    imageSrcDesktop: backgroundImage.src,
    imageFocalPoint: relativeFocalPoint,
    button: react_1["default"].createElement(StageCtaButton_1.StageCtaButton, {
      label: ctaLabel,
      href: ctaTarget,
      target: "_blank"
    }),
    theme: theme
  });
};